<template>
  <div>
    <div v-for="item in list" @click="videoClick(item)" class="videolist">
      <div class="videoimg">
        <img src="@/assets/data/product_1.png" />
      </div>
      <div class="videotitle" v-text="item.title"></div>
      <div class="videodesc" v-text="item.desc"></div>
      <div class="videoinfo flex_between">
        <div>
          <div v-if="item.rmd" class="video_rmd">
            추천
          </div>
          <div class="video_view" v-text="item.viewCount"></div>
          <div :class="item.mark ? 'video_mark_on' :'' " class="video_mark" v-text="item.markCount"></div>
        </div>

        <div class="video_date" v-text="item.date"></div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: "videolist"
    ,props:{
		  list:{
		    type:Array
        ,default:[]
      }
      ,click:{
		    type:Function
        ,default:null
      }
    }
    ,methods:{
      videoClick(info){
        if(this.click !== null){
          this.click(info);
        }
      }
    }
	}
</script>

<style scoped>
.videolist {
  margin: 0 0.278rem 0.458rem 0.278rem;

}

  .videoimg {
    width: 100%;
    display: flex;
  }
  .videoimg img {
    width: 100%;
    height: 100%;
  }

  .videotitle{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.285rem 2.181rem 0 0;
    font-size: 0.444rem;
  }

  .videodesc {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.139rem 0 0 0;
    color: #B9B9B9;
  }

  .videoinfo {
    padding: 0.236rem 0 0 0;
    min-height: 34px;
  }

  .videoinfo > div:nth-child(1) {
    display: flex;
    align-items: center;
  }

  .video_rmd {
    background-color: #F15929;
    color: #fff;
    font-size: 0.306rem;
    -webkit-border-radius: 0.111rem;
    -moz-border-radius: 0.111rem;
    border-radius: 0.111rem;
    padding: 0.069rem 0.125rem;
    margin: 0 0.278rem 0 0;

  }

  .video_view {
    font-size: 0.333rem;
    color: #9F9F9F;
    /*padding:  0 0 0 0.697rem;*/
    padding:  0 0 0 0.417rem;
    position: relative;
  }
  .video_view:before {
    content: '';
    background-image: url('../assets/icon/icon_view.png');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    position: absolute;
    width: 0.306rem;
    height: 0.39rem;
    left: 0;
  }

  .video_mark {
    font-size: 0.333rem;
    color: #9F9F9F;
    padding:  0 0 0 0.778rem;
    position: relative;
  }

  .video_mark_on:before {
    background-image: url('../assets/icon/icon_hart_on.png')!important;
  }

  .video_mark:before {
    content: '';
    background-image: url('../assets/icon/icon_hart_off.png');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    position: absolute;
    width: 0.409rem;
    height: 0.345rem;
    left: 0.278rem;
}

  .video_date {
    font-size: 0.333rem;
    color: #9F9F9F;

  }

</style>



// WEBPACK FOOTER //
// src/components/videolist.vue